export const LOADING = 'loading'
export const FAIL = 'fail'
export const SUCCESS = 'success'